module.exports = __webpack_public_path__ + "static/media/logo-tokped.8caa8e95.png";